import React from "react";
import Column2 from "../Column2";
// import "./Row4.css";

function Row4(props) {
  const { text4, column2Props } = props;

  return (
    <div className="row">
      <div className="column-12">
        <div className="text poppins-medium-limed-spruce-30px">{text4}</div>
      </div>
      <Column2>{column2Props.children}</Column2>
    </div>
  );
}

export default Row4;
